import React, { useState } from "react";
import { RequestDetails as RequestDetailsType } from "./types";

interface RequestDetailsProps {
  details: RequestDetailsType;
  totalAmount: number;
}

export const RequestDetails: React.FC<RequestDetailsProps> = ({ details, totalAmount }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleDetails = () => {
    setIsOpen(!isOpen);
  };

  const getTime = () => {
    return '' + details.dateTime.getHours() + ':00 - ' + (details.dateTime.getHours() + details.duration) + ':00' ;
  };
  const bookingTypes: { [id: string] : string; } = {
    "foto": "ФОТО",
    "video": "ВИДЕО",
    "event": "МЕРОПРИЯТИЕ",
  };

  const getBookingLabel = (type: string) => {
    return '' + bookingTypes[type];
  };

  return (
    <div className="mb-10 w-full">
      <button
        className="flex justify-between items-center p-4 w-full bg-transparent border border-solid cursor-pointer border-neutral-200"
        onClick={toggleDetails}
      >
        <h3 className="m-0 text-sm font-light uppercase">ДЕТАЛИ БРОНИ</h3>
        <div
          className="ml-2.5 w-2.5 h-2.5 border-r-2 border-b-2 border-solid transition-transform border-b-black border-r-black duration-[0.3s] ease-[ease]"
          style={{
            transform: isOpen ? "rotate(225deg)" : "rotate(45deg)",
          }}
        />
      </button>
      <div
        className="overflow-hidden bg-stone-50 border-t-[none] duration-[0.3s] ease-[ease] transition-[height]"
        style={{
          height: isOpen ? "auto" : "0",
          border: isOpen ? "1px solid #e0e0e0" : "none",
        }}
      >
        <div className="p-8 max-sm:p-5">
          <div className="grid gap-5 grid-cols-[repeat(auto-fit,minmax(200px,1fr))] max-sm:grid-cols-[1fr]">
            <div>
              <span className="mb-1.5 mr-3 text-xs text-stone-500">Студия</span>
              <span className="text-sm font-medium">{details.room}</span>
            </div>
            <div>
              <span className="mb-1.5 mr-3 text-xs text-stone-500">
                Дата
              </span>
              <span className="text-sm font-medium">{details.dateTime.toLocaleDateString("en-CA")}</span>
            </div>
            <div>
              <span className="mb-1.5 mr-3 text-xs text-stone-500">
                Время
              </span>
              <span className="text-sm font-medium">{getTime()}</span>
            </div>
            <div>
              <span className="mb-1.5 mr-3 text-xs text-stone-500">
                Продолжительность
              </span>
              <span className="text-sm font-medium">{details.duration} {details.duration < 6? ("часа") : ("часов")}     
              </span>
            </div>
            <div>
              <span className="mb-1.5 mr-3 text-xs text-stone-500">
                Кол-во посетителей
              </span>
              <span className="text-sm font-medium">{details.visitors}</span>
            </div>
            <div>
              <span className="mb-1.5 mr-3 text-xs text-stone-500">
                Тип брони
              </span>
              <span className="text-sm font-medium">{getBookingLabel(details.bookType)}</span>
            </div>

            <div>
              <span className="mb-1.5 mr-3 text-xs text-stone-500">
                Сумма к оплате
              </span>
              <span className="text-sm font-medium text-amber-500">
                {totalAmount} ₽
              </span>
            </div>
          </div>

          {details.equipment.length > 0 && (
          <div className="mt-3">
            <span className="mb-1.5 mr-3 text-xs text-stone-500">
              Оборудование
            </span>
            <div className="flex flex-wrap content-evenly p-3 gap-3 border border-solid border-neutral-200">
              {details.equipment.map((item) => (
                  <div className="min-w-32 mr-12 w-64">
                    <li className="text-xs font-medium">{item.name}: {item.quantity} шт.</li>
                  </div>
              ))}
            </div>
          </div>
          )}

        </div>
      </div>
    </div>
  );
};
